export const productBannerConstants = {
    GET_PRODUCT_BANNER_BY_PRODUCT_PAGE: 'GET_PRODUCT_BANNER_BY_PRODUCT_PAGE',
};
